module.exports = __webpack_public_path__ + "static/box-video.c7d0e8d6.jpg";